import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { change } from 'redux-form';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { FOOTER_MENU } from 'constants/widget';

import { currencyFormatter } from 'utils/prices/formatter';
import { getWidgetTotalPrice } from 'utils/widget/getTotalPrice';
import { getWidgetRentalTotalPrice } from 'utils/widget/getTotalRentalPrice';

import { CheckboxButtonsGroup } from 'components';

import { useQuery } from '@apollo/react-hooks';
import { WIDGET_SETTINGS } from 'graphql/queries/widget';

import useStyles from './styles';

const Footer = ({
  widgetForm,
  accommodationData,
  rentalData,
  cancelButton,
  confirmButton,
  cancelCallback,
  confirmCallback,
  isHideConfirmButton,
  isLastStep,
  isSelectedProduct,
  isAccommodationBooking,
  isHiddenNavigation,
  menuIndex,
  changeFormFieldValue,
  ownerId
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const {  data } = useQuery(WIDGET_SETTINGS, {
    fetchPolicy: 'no-cache',
    variables: { 
      businessOwnerId :ownerId
    },
  });

  const widget = data?.widget || {};
  const { privacyPolicy, termsAndConditions } = widget;

  const isWidgetForm = !!Object.keys(widgetForm || {}).length;
  const currency = isWidgetForm ? widgetForm.values.currency : '';
  const isPrivacy = isWidgetForm ? widgetForm.values.isPrivacy || false : false;

 const calculateTotalPrice = () => {
  if (!isWidgetForm) return '0.00';

  if (rentalData) {
    return currencyFormatter(
      getWidgetRentalTotalPrice(widgetForm, rentalData)
    );
  }

  if (accommodationData) {
    return currencyFormatter(
      getWidgetTotalPrice(widgetForm, accommodationData)
    );
  }

  return '0.00';
};



  const redirectTo = url => {
    if (!url || !url.length) return;
    if (url.indexOf('https') < 0 && url.indexOf('http') < 0) {
      window.open(`https://${url}`, '_blank');
    }
    window.open(url, '_blank');
  };

  return (
    <div className={classes.wrapper}>
      <div>
        {isLastStep && (
          <>
            <CheckboxButtonsGroup
              input={{
                value: {
                  isPrivacy: isPrivacy
                },
                onChange: e => {
                  changeFormFieldValue('isPrivacy', e.isPrivacy);
                }
              }}
              meta={{}}
              className={classes.checkboxWrapper}
              label={
                <div className={classes.confirmPayment}>
                  {t('By confirming the payment, I agree with the')}{' '}
                  <span
                    className={classes.privacy}
                    onClick={() => redirectTo(privacyPolicy)}
                  >
                    {t('Privacy Policy')}
                  </span>
                  {t(' and ')}{' '}
                  <span
                    className={classes.privacy}
                    onClick={() => redirectTo(termsAndConditions)}
                  >
                    {t('Terms & Conditions')}
                  </span>
                  .
                </div>
              }
            />
          </>
        )}
        {!isSelectedProduct && !isHiddenNavigation && (
          <Typography variant="h3" className={classes.navigation}>
            <span className={classes.stepNumber}>{menuIndex + 1} of 5 </span>{' '}
            {FOOTER_MENU[menuIndex].title === 'Activities' &&
            !isAccommodationBooking
              ? t('Accommodations')
              : t(FOOTER_MENU[menuIndex].title)}
          </Typography>
        )}
      </div>
      <div className={classes.buttonsWrapper}>
        <Button
          variant="outlined"
          classes={{ root: classes.cancelBtn }}
          onClick={() => cancelCallback && cancelCallback()}
        >
          {t(cancelButton)}
        </Button>
        {!isHideConfirmButton && (
          <Button
            type="submit"
            variant="outlined"
            classes={{ root: classes.totalBtn }}
            onClick={() => confirmCallback && confirmCallback()}
          >
            {!isSelectedProduct && (
              <>
                <span className={classes.total}>
                  {t('Total')}: {currency} {calculateTotalPrice()}
                </span>{' '}
              </>
            )}
            <span
              className={classNames(classes.next, {
                [classes.withoutTotal]: isSelectedProduct
              })}
            >
              {t(confirmButton)}
            </span>
          </Button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    widgetForm: state.form.widgetForm,
    businessOwner: state.businessOwner
  };
};

const mapDispatchToProps = dispatch => ({
  changeFormFieldValue: (field, value) => {
    dispatch(change('widgetForm', field, value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
